import { TopicModel as Model } from './Model'


export const MODULE_NAME = 'topics'

export const TOPICS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: TOPICS_ROUTES.LAYOUT,
  route: { name: TOPICS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-message-text-outline',
} as const
